import {
  ContractMetadata,
  TrialSource,
} from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/contracts_metadata_pb";
import { ContractStatus } from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/contracts_pb";

export const ENTRY_PERISCOPE = "periscope";

export function generateContractMetadata({
  status,
  entry = ENTRY_PERISCOPE,
}: {
  status: ContractStatus;
  entry: string;
}): ContractMetadata | undefined {
  if (status === ContractStatus.TRIALING) {
    return new ContractMetadata({
      details: {
        case: "trial",
        value: { entry, source: TrialSource.PERISCOPE },
      },
    });
  }

  return undefined;
}
